<template>
  <div class="flex flex-col">
    <a
      v-for="(videoIntro, idx) in videoIntroductions"
      :key="idx"
      class="border border-zinc-300 p-3 md:p-4 flex flex-col md:flex-row md:items-center text-black rounded-lg mb-3"
      target="_blank"
      :href="videoIntro?.url"
      @click="trackPageView(videoIntro?.url)"
    >
      <ResponsiveImage
        v-if="videoIntro.internetnamn"
        class="aspect-square w-14 min-w-14 md:w-11 md:min-w-11 rounded-full overflow-hidden inline-flex mr-3 mb-2 md:mb-0"
        :image="`staff/${videoIntro.internetnamn}`"
      />

      <div class="flex flex-col">
        <span
          class="text-lg font-semibold"
          data-i18n="goToVideo"
        >
          {{ $t('goToVideo') }}
        </span>
        <span
          class="font-secondary text-sm"
          data-i18n="of.tourLeader"
        >
          {{ $t('of.tourLeader') }} {{ videoIntro?.tourleader_name }}
        </span>
      </div>

      <div class="bg-secondary text-white rounded-3xl px-4 py-2 md:py-1 md:w-auto ml-auto flex items-center justify-center mt-2 md:mt-0 hover:bg-secondary/75 w-full">
        <fa
          class="mr-2 pr-1 h5 mb-0"
          icon="video"
        />
        <span
          class="font-semibold"
          data-i18n="seeVideo"
        >
          {{ $t('seeVideo') }}
        </span>
      </div>
    </a>
  </div>
</template>

<script setup>
defineProps({
  videoIntroductions: {
    type: Array,
    required: true,
  },
})

const { trackPageView } = useTracking()
</script>